<template>
	<div class="c-info-gradient" :style="[colorObject]">
		<img v-if="logo" :src="logo" alt="" class="c-info-mix-background" />
	</div>
</template>

<script>
import { IR_THEME_DEFAULT, IR_GRADIENT_THEME_MAP } from '@/utils/enum';

export default {
	data() {
		return {
			logo: '',
			colorObject: {
				'--g-v1': IR_GRADIENT_THEME_MAP[IR_THEME_DEFAULT][0],
				'--g-v2': IR_GRADIENT_THEME_MAP[IR_THEME_DEFAULT][1]
			}
		};
	},
	methods: {
		setMixBgAndColor(logo, color) {
			if (!logo || !color) return;

			this.logo = logo;

			// 渐变应用
			const pickGradientVars = IR_GRADIENT_THEME_MAP[color] || IR_GRADIENT_THEME_MAP[IR_THEME_DEFAULT];
			this.$set(this.colorObject, '--g-v1', pickGradientVars[0]);
			this.$set(this.colorObject, '--g-v2', pickGradientVars[1]);
		}
	}
};
</script>

<style lang="less" scoped>
.c-info-gradient {
	height: 100%;
	background: linear-gradient(180deg, var(--g-v1) 0%, var(--g-v2) 117%);
	overflow: hidden;
	position: relative;

	&::after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: var(--ir-theme-color);
		mix-blend-mode: hue;
		pointer-events: none;
	}
	.c-info-mix-background {
		position: absolute;
		top: -0.18rem;
		right: -0.18rem;
		width: 2.4rem;
		height: 2.4rem;
		opacity: 0.25;
		object-fit: cover;
		mix-blend-mode: multiply;
		filter: grayscale(1);
	}
}
</style>
